export default function SystemConfig() {
  return (
    <div className="space-y-6">
      <div className="card p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-6">System Configuration</h2>

        <div className="space-y-8">
          {/* LLM Provider Settings */}
          <section>
            <h3 className="text-sm font-medium text-gray-700 mb-4">LLM Provider</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="label">Distillation Provider</label>
                <select className="input" defaultValue="claude">
                  <option value="claude">Anthropic (Claude)</option>
                  <option value="openai">OpenAI</option>
                  <option value="venice">Venice AI</option>
                </select>
              </div>
              <div>
                <label className="label">Distillation Model</label>
                <select className="input" defaultValue="claude-3-haiku-20240307">
                  <option value="claude-3-haiku-20240307">Claude 3 Haiku (Recommended)</option>
                  <option value="claude-3-5-haiku-20241022">Claude 3.5 Haiku</option>
                  <option value="claude-3-5-sonnet-20241022">Claude 3.5 Sonnet</option>
                </select>
              </div>
            </div>
          </section>

          {/* Thresholds */}
          <section>
            <h3 className="text-sm font-medium text-gray-700 mb-4">Extraction Thresholds</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="label">Token Threshold</label>
                <input type="number" className="input" defaultValue={2000} />
                <p className="text-xs text-gray-500 mt-1">Min tokens for distillation</p>
              </div>
              <div>
                <label className="label">Confidence Minimum</label>
                <input type="number" className="input" step="0.1" defaultValue={0.3} />
                <p className="text-xs text-gray-500 mt-1">Min confidence to store signals</p>
              </div>
              <div>
                <label className="label">Min Exchange Count</label>
                <input type="number" className="input" defaultValue={4} />
                <p className="text-xs text-gray-500 mt-1">Min conversation exchanges</p>
              </div>
            </div>
          </section>

          {/* Feature Flags */}
          <section>
            <h3 className="text-sm font-medium text-gray-700 mb-4">Feature Flags</h3>
            <div className="space-y-4">
              <ToggleSetting
                label="Personality Distillation"
                description="Extract personality signals from conversations"
                defaultChecked
              />
              <ToggleSetting
                label="Preference Distillation"
                description="Extract domain preferences (music, dining, etc.)"
                defaultChecked
              />
              <ToggleSetting
                label="Persona Generation"
                description="Generate AI-optimized persona documents"
                defaultChecked
              />
              <ToggleSetting
                label="Calibration System"
                description="Allow tenant-specific dimension calibration"
                defaultChecked
              />
              <ToggleSetting
                label="Audit Logging"
                description="Log all profile access and modifications"
                defaultChecked
              />
            </div>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <button className="btn btn-primary">Save Configuration</button>
        </div>
      </div>
    </div>
  )
}

function ToggleSetting({
  label,
  description,
  defaultChecked = false,
}: {
  label: string
  description: string
  defaultChecked?: boolean
}) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <p className="font-medium text-gray-900">{label}</p>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          defaultChecked={defaultChecked}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-personic-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-personic-600"></div>
      </label>
    </div>
  )
}
